// extracted by mini-css-extract-plugin
export default {"errorNotification":"Welcome_errorNotification__3F7in"};